<ng-template #content>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
            (click)="modalRef.dismiss('Cross click')" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="title" i18n="parameters-vehicle|@@classes">Classes</span>
        </div>
      </div>

      <div class="row" *ngIf="vehicle.classes && vehicle.classes[0]">
        <div class="col-12">
          <div class="table-option-toggle">
            <div class="conatainer">

              <div class="row m-0 center firstRow">
                <div class="col-12">
                  <span class="titleRow" i18n="parameters-vehicle|@@classesList">Liste des classes</span>
                </div>
              </div>
              <div class="classArray p-0 m-0">
                <div class="row m-0 center" *ngFor="let vehicleClasses of vehicle.classes">
                  <div class="col-10 center">
                    <span class="p-2"> {{vehicleClasses?.display}}</span>
                  </div>
                  <div class="col-2 alignR">
                    <img src="../../../assets/icon/remove.svg" class="close" aria-label="Close"
                      (click)="delCalsse(vehicleClasses.value)" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


      <div class="row generalrows p-2">
        <div class="col-3 center">
          <span class="span-txt" i18n="parameters-vehicle|@@addClasses">Ajouter une Classe</span>
        </div>
        <div class="col-6">
          <input type="text" placeholder="Nom de la classe" [formControl]="newValueClass">
        </div>
        <div class="col-3">
          <button type="button" class="btn btn-lg primary" (click)="addClasse()"
            i18n="parameters-vehicle|@@validate">Valider</button>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer ">
    <button type="button" class="btn btn-lg primary" (click)="modalRef.dismiss('Cross click')"
      i18n="parameters-vehicle|@@close">Fermer</button>
  </div>
</ng-template>


<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-vehicle|@@vehicle">Véhicule</span>
    </div>
  </div>
  <div class="row report-form">
    <div class="col-6  center">
      <span class="column-title" i18n="parameters-vehicle|@@classes">Classes</span>
    </div>
    <div class="col-6 alignR">
      <button type="button" class="btn btn-lg secondary" (click)="open()">
        <span class="text-span" i18n="parameters-vehicle|@@editClasses">Modifier les Classes</span>
      </button>
    </div>
    <div class="col-12 report-form">
      <span class="column-title" i18n="parameters-vehicle|@@customFields">Champs personnalisés</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-vehicle|@@repairNumber">Numéro OR</span>
          </div>
          <div class="col-2">
            <div class="parameters-toggle">
              <app-generic-toggle (sendData)="vehicle.orNumber = $event; onChange()" [value]="vehicle.orNumber">
              </app-generic-toggle>
            </div>
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-5 center">
            <span class="span-txt" i18n="parameters-vehicle|@@VINnumber">Numéro VIN</span>
          </div>
          <div class="col-2">
            <div class="parameters-toggle">
              <app-generic-toggle (sendData)="vehicle.vinNumber = $event; onChange()" [value]="vehicle.vinNumber">
              </app-generic-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-vehicle/parameters-vehicle.component.html